import { SaleStatusEnum, StatusEnum, TypeOfStock } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("stock")

export class Stock {

    @PrimaryGeneratedColumn("increment", { name: 'stock_id' })
    stockId: number;

    @Column("int", {
        nullable: false,
        name: "unit_id"
    })
    unitId: number;

    // @Column({ type: 'decimal', precision: 10, scale: 2, default: 0, unsigned: true, name: "physical_quantity" })
    // physicalQuantity: number;

    @Column("decimal", {
        nullable: false,
        name: "physical_quantity",
        precision:10,scale:3,
        unsigned:true,
        default:0
    })
    physicalQuantity: number;

    @Column("decimal", {
        nullable: false,
        name: "prepared_quantity",
        precision:10,scale:3,
        unsigned:true,
        default:0
    })
    preparedQuantity: number;

    @Column("decimal", {
        precision:10,scale:3,
        nullable: false,
        name: "intransit_quantity",
        default:0,
        unsigned:true,
    })
    intransitQuantity: number;

    @Column("decimal", {
        precision:10,scale:3,
        nullable: false,
        default: 0,
        name: "reserved_quantity"
    })
    reservedQuantity: number;

    @Column("int", {
        nullable: false,
        name: "item_category_id"
    })
    itemCategoryId: number;

    @Column("int", {
        nullable: true,
        name: "item_sub_category_id"
    })
    itemSubCategoryId: number;

    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;
    @Column("int", {
        nullable: false,
        name: "saleorder_id"
    })
    saleOrderId: number;

    @Column("int", {
        nullable: false,
        name: "size_id",
        default:0,
        comment: "size id not using"
    })
    sizeId: number;

    @Column("decimal", {
        nullable: false,
        precision:10,scale:3,
        default: 0,
        name: "opening_balance",
        unsigned:true
    })
    openingBalance: number;

    @Column("decimal", {
        nullable: false,
        name: "unit_price",
        precision:10,scale:3,
        unsigned:true
    })
    unitPrice: number;



    @Column("decimal", {
        nullable: true,
        name: "min_stock",
        precision:10,scale:3,
        default: 0
    })
    minimumStock: number;

    @Column("int", {
        nullable: false,
        name: "location_id",
        default:0,
    })
    locationId: number;

    @Column({
        type: 'enum',
        enum: TypeOfStock,
        nullable: true,
        name: "type",
        default:TypeOfStock.GOOD,
    })
    type: TypeOfStock;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;


    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;



    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

}

